export const achievementsData = [
  { id: 1, title: 'Top Scorer', icon: 'Award', color: 'bg-yellow-100 text-yellow-500' },
  { id: 2, title: 'Early Bird', icon: 'Star', color: 'bg-purple-100 text-purple-500' },
  { id: 3, title: 'Fast Learner', icon: 'Zap', color: 'bg-teal-100 text-teal-500' },
  { id: 4, title: 'Kind Soul', icon: 'Heart', color: 'bg-pink-100 text-pink-500' },
  { id: 5, title: 'Locked', icon: 'Lock', color: 'bg-slate-100 text-slate-400', locked: true },
];

export const leaderboardData = [
  { rank: 1, name: 'Chibuzo Gabriel', points: 9842, avatar: 'CG', badge: true },
  { rank: 2, name: 'You (Ade Ronke)', points: 8912, avatar: 'AR', badge: false, current: true },
  { rank: 3, name: 'Joshua Prince', points: 8500, avatar: 'JP', badge: false },
];

export const playerStats = {
  gamesPlayed: 124,
  gamesWon: 86,
  gamesLost: 38,
  currentStreak: 7,
};

export interface Subject {
  id: string;
  title: string;
  description: string;
  gradient: string;
  shadowColor: string;
  textColor: string;
  icon: string;
}

export interface Metric {
  id: string;
  icon: string;
  value: string | number;
  label: string;
  bgColor: string;
  iconColor: string;
}

export const metrics: Metric[] = [
  {
    id: 'subjects',
    icon: 'BookOpen',
    value: '9',
    label: 'Subjects Enrolled',
    bgColor: 'bg-teal-50',
    iconColor: 'text-teal-500',
  },
  {
    id: 'topics',
    icon: 'CheckCircle',
    value: '42',
    label: 'Topics Completed',
    bgColor: 'bg-purple-50',
    iconColor: 'text-purple-500',
  },
  {
    id: 'quizzes',
    icon: 'Zap',
    value: '124',
    label: 'Quizzes Passed',
    bgColor: 'bg-orange-50',
    iconColor: 'text-orange-500',
  },
  {
    id: 'streak',
    icon: 'Clock',
    value: '7',
    label: 'Current Streak',
    bgColor: 'bg-blue-50',
    iconColor: 'text-blue-500',
  },
];

export const subjectsgamecard: Subject[] = [
  // {
  //   id: 'financial-accounting',
  //   title: 'Financial Accounting',
  //   description: 'Master the art of tracking money and managing ledgers!',
  //   gradient: 'bg-gradient-to-br from-purple-400 to-purple-600',
  //   shadowColor: 'shadow-purple-200',
  //   textColor: 'text-purple-600',
  //   icon: 'Calendar',
  // },
  {
    id: 'commerce',
    title: 'Commerce',
    description: 'Explore the global world of buying, selling, and trade!',
    gradient: 'bg-gradient-to-br from-teal-400 to-teal-600',
    shadowColor: 'shadow-teal-200',
    textColor: 'text-teal-600',
    icon: 'ShoppingCart',
  },
  {
    id: 'economics',
    title: 'Economics',
    description: 'Understand how resources flow and societies thrive!',
    gradient: 'bg-gradient-to-br from-orange-400 to-orange-600',
    shadowColor: 'shadow-orange-200',
    textColor: 'text-orange-600',
    icon: 'TrendingUp',
  },
  {
    id: 'business-studies',
    title: 'Business\nStudies',
    description: 'Learn the foundations of running a successful enterprise!',
    gradient: 'bg-gradient-to-br from-blue-400 to-blue-600',
    shadowColor: 'shadow-blue-200',
    textColor: 'text-blue-600',
    icon: 'Briefcase',
  },
  // {
  //   id: 'office-practice',
  //   title: 'Office Practice',
  //   description: 'Become a pro at modern workspace management!',
  //   gradient: 'bg-gradient-to-br from-teal-400 to-teal-600',
  //   shadowColor: 'shadow-teal-200',
  //   textColor: 'text-teal-600',
  //   icon: 'Monitor',
  // },
  // {
  //   id: 'insurance',
  //   title: 'Insurance',
  //   description: 'Learn how to protect assets and manage risks!',
  //   gradient: 'bg-gradient-to-br from-purple-400 to-purple-600',
  //   shadowColor: 'shadow-purple-200',
  //   textColor: 'text-purple-600',
  //   icon: 'Shield',
  // },
  // {
  //   id: 'marketing',
  //   title: 'Marketing',
  //   description: 'Discover how to build brands and reach customers!',
  //   gradient: 'bg-gradient-to-br from-orange-400 to-orange-600',
  //   shadowColor: 'shadow-orange-200',
  //   textColor: 'text-orange-600',
  //   icon: 'Users',
  // },
   {
    id: 'geo-1',
    title: 'Geography',
    description: 'Explore the global world!',
    gradient: 'bg-gradient-to-br from-teal-400 to-teal-600',
    shadowColor: 'shadow-teal-200',
    textColor: 'text-teal-600',
    icon: 'Globe',
  },
  // {
  //   id: 'data-processing',
  //   title: 'Data\nProcessing',
  //   description: 'Unlock the power of information and computing!',
  //   gradient: 'bg-gradient-to-br from-blue-400 to-blue-600',
  //   shadowColor: 'shadow-blue-200',
  //   textColor: 'text-blue-600',
  //   icon: 'Grid',
  // },
  {
    id: 'government',
    title: 'Government',
    description: 'Learn how nations are built and laws are made!',
    gradient: 'bg-gradient-to-br from-purple-400 to-purple-600',
    shadowColor: 'shadow-purple-200',
    textColor: 'text-purple-600',
    icon: 'Shield',
  },
   {
    id: 'literature',
    title: 'Literature',
    description: 'Explore the world of stories, poems, and written works!',
    gradient: 'bg-gradient-to-br from-yellow-400 to-yellow-600',
    shadowColor: 'shadow-yellow-200',
    textColor: 'text-yellow-600',
    icon: 'BookOpen',
  },
  {
    id: 'english',
    title: 'English Language',
    description: 'Master the art of communication and literature!',
    gradient: 'bg-gradient-to-br from-purple-400 to-purple-500',
    shadowColor: 'shadow-purple-200',
    textColor: 'text-purple-600',
    icon: 'BookOpen',
  },
  {
    id: 'biology',
    title: 'Biology',
    description: 'Discover the secrets of living organisms!',
    gradient: 'bg-gradient-to-br from-green-400 to-teal-600',
    shadowColor: 'shadow-green-200',
    textColor: 'text-green-600',
    icon: 'Biohazard',
  },
  {
    id: 'chemistry',
    title: 'Chemistry',
    description: 'Explore elements and the reactions that shape our world!',
    gradient: 'bg-gradient-to-br from-red-400 to-red-600',
    shadowColor: 'shadow-red-200',
    textColor: 'text-red-600',
    icon: 'FlaskConical',
  },
  {
    id: 'mathematics',
    title: 'Mathematics',
    description: 'Master numbers, equations, and logical reasoning!',
    gradient: 'bg-gradient-to-br from-blue-400 to-blue-600',
    shadowColor: 'shadow-blue-200',
    textColor: 'text-blue-600',
    icon: 'Calculator',
  },
];